Kanaco = {};
Kanaco.domain = "dx.kannax.com";
Kanaco.api_base = "https://" + Kanaco.domain + "/api";
Kanaco.jQEscape = function (str) {
	return str.replace(new RegExp("(#|;|&|,|\\.|\\+|\\*|~|'|:|\"|!|\\^|\\$|\\[|\\]|\\(|\\)|=|>|\\||\\/|\\\\)","g"),"\\$1");
}
/**
 * 全角から半角への変換関数
 * 入力値の英数記号を半角変換して返却
 * [引数]   strVal: 入力値
 * [返却値] String(): 半角変換された文字列
 */
Kanaco.toHalfWidth = function(strVal) {
  // 半角変換
  var halfVal = strVal.replace(/[！-～]/g,
    function( tmpStr ) {
      // 文字コードをシフト
      return String.fromCharCode( tmpStr.charCodeAt(0) - 0xFEE0 );
    }
  );
 
  // 文字コードシフトで対応できない文字の変換
  return halfVal.replace(/”/g, "\"")
    .replace(/’/g, "'")
    .replace(/‘/g, "`")
    .replace(/￥/g, "\\")
    .replace(/　/g, " ")
    .replace(/〜/g, "~");
}
/**
 * 半角から全角への変換関数
 * 入力値の英数記号を全角変換して返却
 * [引数]   strVal: 入力値
 * [返却値] String(): 全角変換された文字列
 */
Kanaco.toFullWidth = function(strVal) {

  // 半角変換
  var halfVal = strVal.replace(/[!-~]/g,
    function( tmpStr ) {
      // 文字コードをシフト
      return String.fromCharCode( tmpStr.charCodeAt(0) + 0xFEE0 );
    }
  );
 
  // 文字コードシフトで対応できない文字の変換
  return halfVal.replace(/”/g, "\"")
    .replace(/'/g, "’")
    .replace(/`/g, "‘")
    .replace(/\\/g, "￥")
    .replace(/ /g, "　")
    .replace(/~/g, "〜");
}


//------------------------------------------------------------------------------
//
// ajax関連
//  （使用例）
//  Kanaco.ajax({});
//
//------------------------------------------------------------------------------
Kanaco._ajaxParam = {
	type : "POST",
	url: "/ajax/",
	dataType: "json",
	async:true,//非同期通信
	data:{},
	autoAjaxLoadingIconUse: true
};

Kanaco.ajax = function(options) {
  var defer = $.Deferred();
  var _options = $.extend({}, Kanaco._ajaxParam, options || {});
  if (_options.autoAjaxLoadingIconUse) {
    Kanaco.Loader.show();
  }

  var jqXHR = $.ajax(_options);
  jqXHR.done(function(data, textStatus, jqXHR) {
    defer.resolveWith(this, arguments);
  });
  jqXHR.fail(function(jqXHR, textStatus, errorThrown) {
    defer.rejectWith(this, arguments);
  });
  jqXHR.always(function() {
  	if (_options.autoAjaxLoadingIconUse) {
  		Kanaco.Loader.hide();
  	}
  });
  return $.extend({}, jqXHR, defer.promise());
}

Kanaco.api = function(options) {
  if (options.url.match(/\?/)) {
    options.url += '&lang=' + Shopify.locale;
  } else {
    options.lang = Shopify.locale;
  }
  return Kanaco.ajax(options);
}